var map = {
	"./2-1-0.svg": 1968,
	"./2-1-1.svg": 6897,
	"./2-1-2.svg": 1825,
	"./2-2-0.svg": 2667,
	"./2-2-1.svg": 6571,
	"./2-2-2.svg": 5787,
	"./3-0.svg": 1265,
	"./3-1.svg": 3062,
	"./3-2.svg": 3736,
	"./3iLogo.svg": 1839,
	"./8-0.svg": 811,
	"./8-1.svg": 5845,
	"./8-2.svg": 6776,
	"./aurus.svg": 8717,
	"./burger.svg": 3895,
	"./chevronDown.svg": 3918,
	"./chevronLeft.svg": 1829,
	"./chevronRight.svg": 2129,
	"./chevronUp.svg": 6313,
	"./code.svg": 795,
	"./copy-line.svg": 9726,
	"./copy.svg": 8061,
	"./croc.svg": 7845,
	"./cti.svg": 9656,
	"./digitalDesign.svg": 7162,
	"./email.svg": 8789,
	"./error.svg": 6448,
	"./just-ai.svg": 5098,
	"./location.svg": 4130,
	"./logoFooter.svg": 4254,
	"./neuro.svg": 8371,
	"./part.svg": 8051,
	"./participantSK.svg": 2630,
	"./pause.svg": 2209,
	"./phone.svg": 9642,
	"./play.svg": 7393,
	"./progress.svg": 3817,
	"./search-inform.svg": 7789,
	"./sentiment-client-negative.svg": 7934,
	"./sentiment-client-positive.svg": 2611,
	"./shtormtech.svg": 5614,
	"./softline.svg": 6710,
	"./sortArrowDown.svg": 2766,
	"./sortArrowUp.svg": 9873,
	"./speechmate.svg": 5529,
	"./unistar.svg": 4760,
	"./user.svg": 5641,
	"./vk.svg": 5054,
	"./voca.svg": 5561,
	"./voxkit.svg": 2988,
	"./voxys.svg": 381,
	"./youtube.svg": 2595
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8091;